/* This function lists mappings where selected source-feature is used */
import './_style.css'
import {useContext, useEffect, useRef, useState} from "react";
import AuthContext from "../../context/AuthContext";
import {NavLink, useParams} from "react-router-dom";
import * as React from "react";
import BreadCrumbs from "../../components/BreadCrumbs";

// Header of the grid list table
function UsageGridHeader() {

    return (
        <div className="grid-base grid-header feat-srcusage-grid-columns">
            <div>#</div>
            <div>Trg Category ID</div>
            <div>Target Category Name</div>
            <div>Target Feature ID</div>
            <div>Target Feature Name</div>
            <div>Trg LOV Name</div>
            <div>Mapping</div>
        </div>
    )
}

function UsageGridRow(props: any) {

    const {num, dataObj} = props

    // 'function FuncName()' is a React Component and NOT a classic JS function,
    // the below is the JS function inside the React:
    const nameReducer = (f_str: any, max_len: number) => {
        if (f_str && f_str.length > max_len) {
            f_str = f_str.slice(0, max_len) + '...'
        }
        return f_str
    }
    // let objSample: any = {
    //     trgCatUID: 'ffe2c190f1eb7454',
    //     trgCatID: '30000720',
    //     trgCatName: 'Blush',
    //     trgFeatUID: '7da69835bec82c7a',
    //     trgFeatID: 'Effect',
    //     trgFeatName: 'Effect',
    //     trgLovUID: '22ab81c3bb1e5851',
    //     trgLovName: 'Anti-roodheid',
    // }

    let trgCatName = nameReducer(dataObj.trgCatName, 28)
    let trgFeatID = nameReducer(dataObj.trgFeatID, 24)
    let trgFeatName = nameReducer(dataObj.trgFeatName, 60)

    let mappingURL = `../map/${dataObj.trgCatUID}/${dataObj.trgFeatUID}/${dataObj.trgLovUID}/`

    return (
        <div className="grid-base grid-row feat-srcusage-grid-columns">
            <div>{num}</div>
            <div>{dataObj.trgCatID}</div>
            <div>{trgCatName}</div>
            <div>{trgFeatID}</div>
            <div>{trgFeatName}</div>
            <div>{dataObj.trgLovName}</div>
            <div className="grid-row-itemlink">
                <NavLink to={mappingURL}>click here</NavLink>
            </div>
        </div>
    )
}


export default function FeatsListSrcUsage() {
    let {user, logoutUser, authTokens, serverIP} = useContext(AuthContext)

    const {prjid, cat_pk, feat_pk} = useParams()

    const crumbItems = [
        {'name': 'Main', 'link': '/'},
        {'name': 'Mapper Projects', 'link': '../../../projects/1'},
        {'name': 'Features List', 'link': '../1'},
        {'name': 'Source feature usage', 'link': ''}
    ]

    const srcObjRef = useRef({
        srcCatUID: '',
        srcCatID: '',
        srcCatName: '',
        srcFeatUID: '',
        srcFeatID: '',
        srcFeatName: ''})
    let srcObj = srcObjRef.current

    const [trgDataList, setTrgDataList] = useState([])

    useEffect(() => {
        getUsageData()
    }, [])

    let getUsageData = async () => {
        let response = await fetch(`${serverIP}/getsrcfeatusage/`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + String(authTokens.access)
            },
            body: JSON.stringify([prjid, cat_pk, feat_pk]),
        })
        let data = await response.json()

        if (response.status === 200) {
            // console.log('Data:', data)
            setTrgDataList(data.trgData)

            srcObjRef.current = data.srcObj

        } else if (response.statusText === 'Unauthorized') {
            logoutUser()
        }
    }

    const gridRowElements = trgDataList.map((item, index) => {
        return <UsageGridRow
            key={index}
            num={index + 1}
            dataObj={item}
        />
    })

    return (

        <>
            <BreadCrumbs user={user} itemsLinks={crumbItems}/>

            <div style={{margin: '20px 10px', fontSize: '0.85rem'}}>
                {trgDataList?.length > 0 ?
                    <span> The source feature <b>{srcObj.srcFeatName}</b> (ID: {srcObj.srcFeatID}), which belongs to the source
                        category <b>{srcObj.srcCatName}</b> (ID: {srcObj.srcCatID}), is used in {trgDataList?.length} target mappings:
                </span>
                    :
                    <span>The feature <b>{srcObj.srcFeatName}</b> (ID: {srcObj.srcFeatID}), which belongs to the source
                    category <b>{srcObj.srcCatName}</b> (ID: {srcObj.srcCatID}) do not take part in any mappings yet.</span>
                }</div>

            <UsageGridHeader/>

            <div className="grid-rows-container">{gridRowElements}</div>

        </>
    )
}
